import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as dolomite from '../dolomite'

export const RESOURCE = {
  payload: {
    alias: 'chat',
    appAlias: dolomite.RESOURCE.payload.alias,
    description: 'Ask questions about Ascend and Princeton architecture',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Chat',
    page: { id: prebuilt.Page.Id.DolomiteChat },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
